import { makeStyles } from '@material-ui/core/styles'
import { CircularProgress, Typography } from '@material-ui/core'
import { shape, number } from 'prop-types'

const styles = makeStyles({
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
})

const CampaignCompletionChart = (props) => {
  const classes = styles()
  const { data, unique_contacts } = props

  // function to count the total contacts on the report
  const countDataResponses = (data) => {
    return (
      Number(data['email_attempt_completed']) +
      Number(data['phone_attempt_completed']) +
      Number(data['sms_attempt_completed'])
    )
  }
  // function to count out total number of contacts
  const countTotalContactsMethods = (jsonList) => {
    return (
      Number(jsonList['email_counter']) +
      Number(jsonList['phone_counter']) +
      Number(jsonList['sms_counter'])
    )
  }

  // Create variables from values of matching keys
  let toRender3 = <br />

  let percentage = Math.min(
    100,
    Math.round(
      (countDataResponses(data) / countTotalContactsMethods(unique_contacts)) *
        100,
    ),
  )

  toRender3 = (
    <div className={classes.centerDiv}>
      <Typography component="span">
        Campaign Total Progress...
        <br />
        {percentage}% Complete
      </Typography>
      <CircularProgress size={175} variant="determinate" value={percentage} />
    </div>
  )

  return <div>{toRender3}</div>
}

export default CampaignCompletionChart

CampaignCompletionChart.propTypes = {
  data: shape({
    email_attempt_completed: number,
    phone_attempt_completed: number,
    sms_attempt_completed: number,
  }),
  unique_contacts: shape({
    email_counter: number,
    phone_counter: number,
    sms_counter: number,
  }),
}
